import routes from './routes';
import { SetRoutes } from 'components';

const VipClubPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VipClubPages;
